/**
 * hasImageUploadCare
 * Hàm kiểm tra xem có phải src là ảnh từ upload care hay không (sau này nên đặt tên là isUploadCareImage)
 * @param src :string
 * @returns src
 */
export default (src: string): boolean => {
  if (!src) {
    return false;
  }
  if (src.indexOf('ucarecdn.com/') != -1 || src.indexOf('cdn.gempages.net/') != -1) {
    return true;
  }
  return false;
};
